
const routes = [
  {
    path: '/',
    component: () => import('src/layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/public/LandingPage.vue') },
      { path: '/home', component: () => import('pages/HomePage.vue') },
      { path: '/apps', component: () => import('pages/public/AppsPage.vue') },
      { path: '/apps/:appRef', component: () => import('pages/public/AppsPage.vue') },
      { path: '/apps/:appRef/privacy', component: () => import('pages/public/AppPrivacyPage.vue') },
      { path: '/apps/:appRef/terms', component: () => import('pages/public/AppTermsPage.vue') },
      { path: '/apps/:appRef/:section', component: () => import('pages/public/AppsPage.vue') },
      { path: '/terms', component: () => import('pages/public/TermsAndConditionsPage.vue') },
      { path: '/activity/:id', component: () => import('pages/public/ActivityPage.vue') },
      { path: '/lessons/:groupId', component: () => import('src/pages/GroupPage.vue') },
      { path: '/packs', component: () => import('pages/public/PacksPage.vue') },
      { path: '/pack/:id', component: () => import('pages/public/PackPage.vue') },
      { path: '/session', component: () => import('src/pages/SessionPage.vue') },
      { path: '/pill/:id', component: () => import('src/pages/public/PillPage.vue') },
      { path: '/grammar/:ref', component: () => import('pages/public/GrammarPointPage.vue') },
      { path: '/classroom/:groupId/:eventId', component: () => import('pages/tutoring/ClassroomPage.vue') },
      { path: '/leaderboard', component: () => import('pages/public/LeaderboardPage.vue') },
      { path: '/pricing', component: () => import('src/pages/tutoring/PricingPage.vue') },
      { path: '/about', component: () => import('src/pages/public/AboutPage.vue') },
      { path: '/avatar', component: () => import('src/pages/public/AvatarPage.vue') },
      { path: '/changelog', component: () => import('src/pages/public/ChangeLogPage.vue') },
      { path: '/privacy', component: () => import('src/pages/public/PrivacyPage.vue') },
      { path: '/widgets', component: () => import('src/pages/public/widgets/NumbersWidgetPage.vue') },
      { path: '/pharmacy', component: () => import('src/pages/public/PharmacyPage.vue') },
      { path: '/membership', component: () => import('src/pages/public/MembershipPage.vue') },

      //users
      { path: '/user', component: () => import('src/pages/user/UserPage.vue') },

      //students only
      { path: '/user/:uid', component: () => import('src/pages/user/UserPagePublic.vue') },
      //{ path: '/contract/:uid', component: () => import('src/pages/tutoring/ContractPage.vue') },

      { path: '/company/:companyId', component: () => import('src/pages/companies/CompanyPage.vue') },
      { path: '/test-playground', component: () => import('src/pages/TestPlayground.vue') },

    ]

  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/public/Error404.vue')
  }
]

export default routes
